import { Module } from "vuex";
import http from "@/utils/DuduAjax";

import { API_SYSTEM_ENUMS } from "@/configs/Apis";

const module: Module<{ enums: any }, any> = {
  namespaced: true,
  state: {
    enums: null
  },
  mutations: {
    enums(state, data) {
      state.enums = data;
    }
  },

  getters: {
    enums(state) {
      return JSON.parse(JSON.stringify(state.enums || {})) || {};
    },
    getEnumsByKey(state) {
      return (key: string) => state.enums[key];
    }
  },

  actions: {
    getEnums({ commit }) {
      const api = `${API_SYSTEM_ENUMS}?_=${new Date().valueOf()}`;
      return http.get(api).then((enumsData) => commit("enums", enumsData));
    }
  }
};

export default module;
